"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AUTH_ENV_KEY = void 0;
const AUTH_ENV_KEY = exports.AUTH_ENV_KEY = {
  SELF_AUTH_FLG: 'SELF_AUTH_FLG',
  TEST_FLG: 'TEST_FLG'
};
const getEnv = key => {
  if (!key) {
    return null;
  }
  if (typeof AUTH_ENV === 'undefined') {
    return null;
  }

  // eslint-disable-next-line no-undef
  return AUTH_ENV[key];
};
var _default = exports.default = Object.freeze({
  getEnv
});